var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoVtNoText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 144,
    viewBox: "0 0 250 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8466 98.75L0 143.75H6.90339L28.75 98.75H21.8466Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9765 45L61.25 98.75H68.2735L95 45H87.9765Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6534 45L77.5 0H70.6087L48.75 45H55.6534Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 98.75L77.5 143.75H84.7035L107.5 98.75H100.309Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.467 45L138.75 98.75H145.783L172.5 45H165.467Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.141 45L155 0H148.097L126.25 45H133.141Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.097 98.75L156.25 143.75H163.141L185 98.75H178.097Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.979 45L216.25 98.75H223.283L250 45H242.979Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.954 45L233.75 0H226.559L203.75 45H210.954Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.744 91.25C28.407 91.25 20 82.5531 20 71.875C20 61.1969 28.407 52.5 38.744 52.5C49.0809 52.5 57.5 61.1969 57.5 71.875C57.5 82.5531 49.0809 91.25 38.744 91.25Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.25 91.25C105.916 91.25 97.5 82.5531 97.5 71.875C97.5 61.1969 105.904 52.5 116.25 52.5C126.596 52.5 135 61.1969 135 71.875C135 82.5531 126.596 91.25 116.25 91.25Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.381 91.25C183.7 91.25 175 82.5531 175 71.875C175 61.1969 183.687 52.5 194.381 52.5C205.075 52.5 213.75 61.1969 213.75 71.875C213.75 82.5655 205.063 91.25 194.381 91.25Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoVtNoText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-VT-noText.65035d925e2e5c35a097d50d1cbce9ea.svg";